// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Bool = require("relude/src/Relude_Bool.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

function container(labelPosition) {
  var tmp;
  switch (labelPosition) {
    case /* Bottom */0 :
        tmp = "columnReverse";
        break;
    case /* Right */2 :
        tmp = "rowReverse";
        break;
    case /* Top */3 :
        tmp = "column";
        break;
    case /* Left */1 :
    case /* NoLabel */4 :
        tmp = "row";
        break;
    
  }
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.flexDirection(tmp),
                tl: /* [] */0
              }
            });
}

function switchContainer(styleType) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.backgroundColor(styleType && styleType._0 ? ({
                        TAG: /* Teal */6,
                        _0: /* Medium */2
                      }) : ({
                        TAG: /* White */7,
                        _0: /* Light */2
                      })),
              tl: {
                hd: BrowserStyle.border(BrowserStyle.rem(0.0625), "solid", styleType ? (
                        styleType._0 ? ({
                              TAG: /* Teal */6,
                              _0: /* Medium */2
                            }) : ({
                              TAG: /* Grey */2,
                              _0: /* Light */3
                            })
                      ) : ({
                          TAG: /* Grey */2,
                          _0: /* Lightest */4
                        })),
                tl: {
                  hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.8125)),
                  tl: {
                    hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
                    tl: {
                      hd: BrowserStyle.height(BrowserStyle.rem(1.625)),
                      tl: {
                        hd: BrowserStyle.padding(BrowserStyle.rem(0.125)),
                        tl: {
                          hd: BrowserStyle.transitions({
                                hd: Curry._4(BrowserStyle.Transition.shorthand, 225, undefined, BrowserStyle.easeInOut, "background-color"),
                                tl: {
                                  hd: Curry._4(BrowserStyle.Transition.shorthand, 225, undefined, BrowserStyle.easeInOut, "border-color"),
                                  tl: /* [] */0
                                }
                              }),
                          tl: {
                            hd: BrowserStyle.width(BrowserStyle.rem(2.6875)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function hiddenPusher(value) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.flex(value ? ({
                        NAME: "num",
                        VAL: 1.0
                      }) : "none"),
              tl: {
                hd: BrowserStyle.transitions({
                      hd: Curry._4(BrowserStyle.Transition.shorthand, 225, undefined, BrowserStyle.easeInOut, "flex"),
                      tl: /* [] */0
                    }),
                tl: /* [] */0
              }
            });
}

function switchKnob(styleType) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.backgroundColor(styleType ? (
                      styleType._0 ? ({
                            TAG: /* White */7,
                            _0: /* Light */2
                          }) : ({
                            TAG: /* Grey */2,
                            _0: /* Light */3
                          })
                    ) : ({
                        TAG: /* Grey */2,
                        _0: /* Lightest */4
                      })),
              tl: {
                hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.625)),
                tl: {
                  hd: BrowserStyle.flex("none"),
                  tl: {
                    hd: BrowserStyle.height(BrowserStyle.rem(1.25)),
                    tl: {
                      hd: BrowserStyle.transitions({
                            hd: Curry._4(BrowserStyle.Transition.shorthand, 225, undefined, BrowserStyle.easeInOut, "background-color"),
                            tl: /* [] */0
                          }),
                      tl: {
                        hd: BrowserStyle.width(BrowserStyle.rem(1.25)),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Small */2, /* Normal */0);
}

var valueLabel = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: /* [] */0
        }));

var Styles = {
  container: container,
  switchContainer: switchContainer,
  hiddenPusher: hiddenPusher,
  switchKnob: switchKnob,
  valueLabel: valueLabel
};

function getStyleType(isDisabled, value) {
  if (isDisabled) {
    return /* Disabled */0;
  } else {
    return /* Enabled */{
            _0: value
          };
  }
}

function BrowserComponents_Switch(Props) {
  var className = Props.className;
  var isDisabledOpt = Props.isDisabled;
  var labelPositionOpt = Props.labelPosition;
  var onValueChange = Props.onValueChange;
  var value = Props.value;
  var isDisabled = isDisabledOpt !== undefined ? isDisabledOpt : false;
  var labelPosition = labelPositionOpt !== undefined ? labelPositionOpt : /* Left */1;
  var styleType = getStyleType(isDisabled, value);
  var tmp;
  if (labelPosition >= 4) {
    tmp = null;
  } else {
    var tmp$1;
    if (value) {
      tmp$1 = "Yes";
    } else if (labelPosition >= 3) {
      tmp$1 = "No";
    } else {
      switch (labelPosition) {
        case /* Bottom */0 :
            tmp$1 = "No";
            break;
        case /* Left */1 :
            tmp$1 = " No";
            break;
        case /* Right */2 :
            tmp$1 = "No ";
            break;
        
      }
    }
    tmp = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
              className: valueLabel,
              children: tmp$1
            }), React.createElement(BrowserComponents_Spacer.make, {
              size: /* XSmall */2
            }));
  }
  var tmp$2 = {
    children: React.createElement(BrowserComponents_FlexRow.make, {
          className: container(labelPosition),
          children: null
        }, tmp, React.createElement(BrowserComponents_FlexRow.make, {
              className: switchContainer(styleType),
              children: null
            }, React.createElement("div", {
                  className: hiddenPusher(value)
                }), React.createElement("div", {
                  className: switchKnob(styleType)
                }))),
    disabled: isDisabled,
    onClick: (function (param) {
        return Curry._1(onValueChange, Relude_Bool.inverse(value));
      })
  };
  if (className !== undefined) {
    tmp$2.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_Button.Base.make, tmp$2);
}

var make = BrowserComponents_Switch;

exports.Styles = Styles;
exports.getStyleType = getStyleType;
exports.make = make;
/* valueLabel Not a pure module */
